import React from 'react';
import {connect} from 'react-redux';

import {BenchlingState} from 'redux-stores/reduceApp';
import {BenchlingDispatch, Thunk} from 'redux-stores/Store';
import MultiSelectStarsAwareSchemaSelector, {
  MultiSelectStarsAwareSchemaSelectorProps,
} from 'samples/MultiSelectStarsAwareSchemaSelector';
import {fetchStarredStorableSchemas, toggleStorableSchemaStar} from 'stars/StarsReduxActions';
import {ToggleDisplayMode} from 'ui-library/floating-ui/Float';
import {FloatingInteraction} from 'ui-library/floating-ui/FloatingConstants';
import Popover from 'ui-library/floating-ui/Popover';

import {Section} from './SchemaStarsUtil';
import StarsAwareSchemaSelector, {StarsAwareSchemaSelectorProps} from './StarsAwareSchemaSelector';

function mapStateToProps(state: BenchlingState): {starredSchemaIds: Array<string>} | {} {
  return {
    starredSchemaIds: state.models.stars.storableSchemaIds!,
  };
}

interface BaseStorableSchemaSelectorProps {
  starredSchemaIds: Array<string>;
  fetchStarredStorableSchemas: () => (dispatch: BenchlingDispatch) => void;
  toggleStorableSchemaStar: (storableSchemaId: string) => Thunk<void>;
  sections?: Array<Section>;
  isMulti?: boolean;
  shouldDefaultIfSingleItem?: boolean;
}

export type StorableSchemaSelectorProps = Omit<StarsAwareSchemaSelectorProps, 'onToggleStar'> &
  BaseStorableSchemaSelectorProps & {isMulti?: false};
export type MultiSelectStorableSchemaSelectorProps = Omit<
  MultiSelectStarsAwareSchemaSelectorProps,
  'onToggleStar'
> &
  BaseStorableSchemaSelectorProps & {isMulti: true};

export class StorableSchemaSelector extends React.Component<
  StorableSchemaSelectorProps | MultiSelectStorableSchemaSelectorProps
> {
  static defaultProps = StarsAwareSchemaSelector.defaultProps;

  override componentDidMount(): void {
    this.props.fetchStarredStorableSchemas();
  }

  override render(): JSX.Element {
    const sharedProps = {
      onToggleStar: this.props.toggleStorableSchemaStar,
      schemas: this.props.schemas,
      starredSchemaIds: this.props.starredSchemaIds,
      sections: this.props.sections,
      getSchemaOwner: this.props.getSchemaOwner,
      isDisabled: this.props.isDisabled,
    };

    return (
      <Popover
        toggleDisplayMode={ToggleDisplayMode.BLOCK}
        interaction={FloatingInteraction.HOVER}
        isDisabled={
          !this.props.isDisabled ||
          this.props.disabledMessage == null ||
          this.props.disabledMessage.length === 0
        }
        renderContent={() => this.props.disabledMessage}
      >
        {this.props.isMulti ? (
          <MultiSelectStarsAwareSchemaSelector
            {...sharedProps}
            error={this.props.error}
            onSelectSchemaIds={this.props.onSelectSchemaIds}
            selectedSchemaIds={this.props.selectedSchemaIds}
          />
        ) : (
          <StarsAwareSchemaSelector
            {...sharedProps}
            error={this.props.error}
            onChange={this.props.onChange}
            selectedSchemaId={this.props.selectedSchemaId}
            shouldShowNoSchemaOption={this.props.shouldShowNoSchemaOption}
            shouldDefaultIfSingleItem={this.props.shouldDefaultIfSingleItem}
          />
        )}
      </Popover>
    );
  }
}

export default connect(mapStateToProps, {fetchStarredStorableSchemas, toggleStorableSchemaStar})(
  StorableSchemaSelector
);
